module.exports = __webpack_public_path__ + "static/Canela-ThinItalic-Web-087778b74820b56f4bf16ea1f7830653.woff";